import PendingPayment from 'app/src/payments/PendingPayment';
import PaymentTypeManager from 'app/src/payments/PaymentTypeManager';

/**
 * Class definition of a credit account payment
 */
export default class CreditAccountPayment extends PendingPayment {
  /**
   * Constructor
   *
   * @param amount {Decimal}   The amount of the credit account payment
   * @param creditAccountID {Number}  The ID of the credit account to make the payment
   * @param saleID {Number}   The ID of the sale for the payment
   */
  constructor(amount = 0, creditAccountID = 0, saleID = 0) {
    super(
      amount,
      PaymentTypeManager.getPaymentIdForType(PaymentTypeManager.Types.CREDIT_ACCOUNT),
      saleID
    );

    this._allowMultiple = false;
    this._model.set('creditAccountID', creditAccountID);
  }
}
